<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <div class="row">
                <h5 class="card-title text-primary mx-auto">{{ localizationStore.translate('api.settings') }}</h5>
            </div>

            <!-- action="{{ route('lob_settings_update') }}" -->
            <form>
                <div class="row mx-auto">
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label class="label-green" for="clixlo_key">{{ localizationStore.translate('api.key.name') }}</label>
                                    <select id="access_token" names="access_token" class="form-control" v-model="api_key_type">
                                        <option v-for="(api,index) in apiSettingStore.api_list" :value="api.id">{{api.name}}</option>
                                    </select>
                                    <!-- <input type="text" class="form-control" required :placeholder="localizationStore.translate('clixlo.api.key.placeholder')" id="clixlo_key"
                                        name="clixlo_key" v-model="clixlo_key"> -->
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label class="label-green" for="api_key">{{ localizationStore.translate('title.api.key') }}</label>
                                    <input type="text" class="form-control" required :placeholder="localizationStore.translate('title.api.key.placeholder')" id="api_key"
                                        name="api_key" v-model="api_key">
                                </div>
                            </div>
                        </div>
                        <div class="custom-control custom-checkbox  ml-1 mb-1">
                            <input class="custom-control-input" id="clixlo_checkbox" type="checkbox" tabindex="3" v-model="api_key_mode" v-on:change="checkboxChecked($event,'api_key')"/>
                            <label class="custom-control-label label-green" for="clixlo_checkbox"> {{ localizationStore.translate('api.enable') }} </label>
                        </div>
                        <div class="col-md-12 col-lg-12 col-sm-12">
                            <button type="button" class="btn btn-primary mr-2" @click="saveSettings">{{ localizationStore.translate('save.changes') }}</button>
                            <button type="button" data-dismiss="modal" class="btn btn-outline-secondary">{{ localizationStore.translate('close') }}</button>
                            <button
                                type="button"
                                class="btn btn-outline-primary ml-1"
                                @click="isPlayerActive = !isPlayerActive"
                            >
                                <vue-feather size="12" type="film" />
                                Tutorial
                            </button>
                        </div>
                </div>
            </form>
        </div>
    </div>
    <div
        v-if="isPlayerActive"
        class="modal fade text-left show"
        tabindex="-1"
        aria-labelledby="myModalLabel17"
        aria-modal="true"
        role="dialog"
        style="padding-right: 15px;display:block;background: #000000b5;"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-lg"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="isPlayerActive = !isPlayerActive">
                        <span aria-hidden="true" >×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <iframe
                            :src="businessStore.tutorials.apiSetting"
                            style="margin:auto;height: 66vh;width: 100%;"
                            width="560"
                            height="315"
                            title="Creditfixrr Access API Settings"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../../stores/LocalizationStore.js'
import { useApiSettingStore } from '../../../../../stores/ApiSettingStore.js'
import axios from 'axios'
export default{
    components:{
    },
    setup() {
        return {
            api_key: ref(null),
            api_key_type: ref(null),

            api_key_mode: ref(false),

            userStore : useUserStore(),
            businessStore : useBusinessStore(),
            localizationStore : useLocalizationStore(),
            apiSettingStore : useApiSettingStore(),
            isPlayerActive: ref(false),
        }
    },
    watch: {
        async 'apiSettingStore.apiKeys' (value) {
            if(!_.isEmpty(value)){
                this.api_key = value.api_key_name;
                this.api_key_type = value.api_key_type;
                this.api_key_mode =  value.mode == this.apiSettingStore.ACTIVE ? true : false;
            }
        },
    },
    mounted(){
        this.apiSettingStore.fetchApiSetting();
    },
    methods:{
        saveSettings(){
            let data= {};
            data = {
                'api_key_name':this.api_key,
                'type': this.api_key_type,
                'mode':this.api_key_mode
            }

            if(!_.isEmpty(data)){
                const route = this.$router.resolve(
                    {
                        name: 'save-api-key-settings',
                    }
                );

                axios.post(route.href,data).then(({data})=>{
                    if(data.error != true){
                        toastr.success(data.message,'Api Settings');
                    }else{
                        toastr.error(data.message,'Api Settings');
                    }
                })
            }else{
                toastr.error('Make sure you selected App to sync your clients and added an API key.','Api Settings');
            }

        },
        selectMode(val){
            this.mode = val
        },
        checkboxChecked(event,type){
            // const array = ['clixlo_mode','connectally_mode','GO']
            // array.forEach(element => {
            //     if(element == type){
            //     }
            // });
        }
    }
}
</script>
